module.exports = __webpack_public_path__ + "img/damare06.e62db6bc.jpg";